export default {
    baseUrl: '/dev-api'
};
